import { render, staticRenderFns } from "./FollowUpItem.vue?vue&type=template&id=33a0b3b1&scoped=true&"
import script from "./FollowUpItem.vue?vue&type=script&lang=js&"
export * from "./FollowUpItem.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpItem.vue?vue&type=style&index=0&id=33a0b3b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a0b3b1",
  null
  
)

export default component.exports